<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      pageName: ""
    }
  },
  mounted() {
    if (window.location.href.indexOf("searchPage") > -1) {
      this.pageName = "searchPage"
    }
  },
  created() {

  }
}
</script>

<style>
.animated {
  -webkit-animation-duration: 1.5s;
  animation-duration: 1.5s;
}
body {
  background-color: #e6e7e8 !important;
}
.flex-zTopBottom {
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.scale-img:hover {
  scale: 1.1;
}
.flex-ac {
  -webkit-box-align: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  align-items: center;
}
.flex-hc {
  -webkit-box-pack: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  justify-content: center;
}
#container {
  width: 90%;

  margin: 0 auto;
  position: relative;
}

html,
body {
  height: 100%;
  width: 100%;
}

.el-textarea__inner {
  height: 90px;
  resize: none;
  line-height: 60px;
}
.el-button--primary {
  background-color: #f18700;
  border-color: #f18700;
}
@media screen and (max-width: 997px) {
  #container {
    width: 100%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue